import SEO from "../components/common/SEO"
import PageBanner from "../components/layout/PageBanner"

export default function PrivacyPolicy() {
  return (
    <>
      <SEO
        title="Politique de confidentialité"
        description="Politique de confidentialité concernant l'utilisation du site et le traitement des données personnelles."
        keywords="politique de confidentialité, données personnelles, protection des données"
        url="https://www.khenissitextiles.com/politique-confidentialite"
      />

      <PageBanner
        title="Politique de confidentialité"
        subtitle="Protection et traitement de vos données personnelles."
      />

      <section className="py-16 lg:py-24">
        <div className="container mx-auto px-4 lg:px-8 max-w-4xl">

          <div className="prose prose-gray max-w-none">

            <h2>1. Introduction</h2>

            <p>
              La présente politique de confidentialité explique comment
              les informations personnelles collectées via ce site web
              sont utilisées et protégées.
            </p>

            <p>
              En utilisant ce site, vous acceptez les pratiques décrites
              dans cette politique.
            </p>

            <h2>2. Données collectées</h2>

            <p>
              Nous pouvons collecter certaines informations lorsque vous :
            </p>

            <ul>
              <li>Remplissez un formulaire de contact.</li>
              <li>Nous contactez par téléphone ou WhatsApp.</li>
              <li>Nous envoyez un e-mail.</li>
            </ul>

            <p>
              Les informations collectées peuvent inclure :
            </p>

            <ul>
              <li>Nom et prénom.</li>
              <li>Adresse e-mail.</li>
              <li>Numéro de téléphone.</li>
              <li>Contenu de votre message.</li>
            </ul>

            <h2>3. Utilisation des données</h2>

            <p>
              Les informations recueillies sont utilisées uniquement pour :
            </p>

            <ul>
              <li>Répondre à vos demandes.</li>
              <li>Fournir des informations sur nos produits et services.</li>
              <li>Améliorer la qualité de notre service client.</li>
            </ul>

            <h2>4. Conservation des données</h2>

            <p>
              Les données sont conservées uniquement pendant la durée
              nécessaire au traitement de votre demande ou conformément
              aux obligations légales applicables.
            </p>

            <h2>5. Partage des données</h2>

            <p>
              Vos données personnelles ne sont ni vendues ni louées à des
              tiers. Elles peuvent être partagées uniquement lorsque cela
              est nécessaire au fonctionnement du site ou en cas
              d'obligation légale.
            </p>

            <h2>6. Sécurité</h2>

            <p>
              Nous mettons en œuvre des mesures raisonnables afin de
              protéger vos informations contre tout accès non autorisé,
              perte, divulgation ou modification.
            </p>

            <h2>7. Cookies</h2>

            <p>
              Ce site peut utiliser des cookies afin d'améliorer
              l'expérience utilisateur et d'analyser le trafic.
            </p>

            <p>
              Vous pouvez configurer votre navigateur pour refuser ou
              supprimer les cookies à tout moment.
            </p>

            <h2>8. Liens externes</h2>

            <p>
              Notre site peut contenir des liens vers des services
              externes tels que WhatsApp ou Google Maps. Nous ne sommes
              pas responsables des politiques de confidentialité de ces
              services tiers.
            </p>

            <h2>9. Vos droits</h2>

            <p>
              Vous pouvez demander l'accès, la rectification ou la
              suppression de vos données personnelles en nous contactant.
            </p>

            <h2>10. Contact</h2>

            <p>
              Pour toute question concernant cette politique de
              confidentialité, vous pouvez nous contacter via les moyens
              indiqués sur la page Contact.
            </p>

            <h2>11. Modifications</h2>

            <p>
              Nous nous réservons le droit de modifier cette politique de
              confidentialité à tout moment afin de refléter les évolutions
              légales ou techniques du site.
            </p>

            <p className="mt-10 text-sm text-gray-500">
              Dernière mise à jour : Juin 2026
            </p>

          </div>

        </div>
      </section>
    </>
  )
}